var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldViewType } from "@/components/fields/viewType";
import DockEast from "@/components/layout/docks/dockEast";
import DockNorth from "@/components/layout/docks/dockNorth";
import DockSouth from "@/components/layout/docks/dockSouth";
import DockWest from "@/components/layout/docks/dockWest";
import DrawerEast from "@/components/layout/drawers/drawerEast";
import DrawerNorth from "@/components/layout/drawers/drawerNorth";
import DrawerSouth from "@/components/layout/drawers/drawerSouth";
import DrawerWest from "@/components/layout/drawers/drawerWest";
import Footer from "@/components/layout/footer";
import Header from "@/components/layout/header";
import MenuEast from "@/components/layout/menuEast";
import MenuNorth from "@/components/layout/menuNorth";
import MenuWest from "@/components/layout/menuWest";
import PreviewEast from "@/components/layout/previews/previewEast";
import PreviewNorth from "@/components/layout/previews/previewNorth";
import PreviewSouth from "@/components/layout/previews/previewSouth";
import PreviewWest from "@/components/layout/previews/previewWest";
import { Merge } from "@/components/widgets/module/massupdate/merge";
import { useGetModuleListQuery, useSaveRecordMutation } from "@/store/api";
import { LoaderImage } from "@/utils/loader";
import { faChevronsLeft } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/joy";
import { t } from "i18next";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useParams, useNavigate } from "react-router-dom";
export default function ModuleMerge() {
    var _this = this;
    var module = useParams().module;
    var state = useLocation().state;
    var ids = (state !== null ? state : []).ids;
    var navigate = useNavigate();
    // Load records
    var where = [
        {
            field: "id",
            operator: "eq",
            value: ids,
        },
    ];
    var moduleList = useGetModuleListQuery({
        table: module,
        params: {
            where: where,
        },
    }).data;
    var _a = useState([]), records = _a[0], setRecord = _a[1];
    useEffect(function () {
        var dataModule = moduleList === null || moduleList === void 0 ? void 0 : moduleList.data;
        setRecord((dataModule === null || dataModule === void 0 ? void 0 : dataModule.records) || []);
    }, [moduleList]);
    var _b = useState(), primary = _b[0], setPrimary = _b[1];
    var _c = useState(setSecondaryFunc(records, primary)), secondary = _c[0], setSecondary = _c[1];
    useEffect(function () {
        setPrimary(records[0]);
        // Sencondary ids
        setSecondary(setSecondaryFunc(records, records[0]));
    }, [records]);
    /**
     * Get secondary records
     * @param records
     * @param prim
     * @returns
     */
    function setSecondaryFunc(records, prim) {
        var secondaryIds = records.filter(function (item) { return item !== prim; });
        return secondaryIds;
    }
    // Update primary
    var fieldIsUpdated = function (field) {
        setPrimary(__assign(__assign({}, primary), field));
    };
    // Enregistrement record
    var saveRecordMutaion = useSaveRecordMutation()[0];
    var _d = useState(false), isLoad = _d[0], setIsLoad = _d[1];
    var saveRecord = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setIsLoad(true);
                    return [4 /*yield*/, saveRecordMutaion({
                            body: { module: module, record: primary } || {},
                        }).unwrap()];
                case 1:
                    _a.sent();
                    if (primary.id.length > 0) {
                        toast.success("Enregistrement terminé.");
                        setIsLoad(false);
                        navigate("/modules/".concat(module));
                    }
                    else {
                        navigate("/modules/".concat(module));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    setIsLoad(false);
                    console.log(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", __assign({ className: "layout overflow-hidden flex flex-col w-full h-full page" }, { children: [_jsx(Header, {}), _jsxs("div", __assign({ className: "flex h-full flex-row flex-auto bg-yellow-400 overflow-hidden" }, { children: [_jsx(MenuWest, {}), _jsxs("div", __assign({ className: "flex flex-col flex-auto overflow-hidden" }, { children: [_jsx(MenuNorth, {}), _jsxs("section", __assign({ className: "relative flex flex-row flex-auto overflow-hidden z-30" }, { children: [_jsx(DrawerWest, {}), _jsxs("div", __assign({ className: "relative flex flex-col flex-auto overflow-hidden" }, { children: [_jsx(DrawerNorth, {}), _jsxs("div", __assign({ className: "flex flex-row flex-auto overflow-hidden" }, { children: [_jsx(DockWest, {}), _jsxs("div", __assign({ className: "flex flex-col flex-auto overflow-hidden" }, { children: [_jsx(DockNorth, {}), _jsxs("div", __assign({ className: "relative flex flex-row flex-auto overflow-hidden" }, { children: [_jsx(PreviewWest, {}), _jsxs("div", __assign({ className: "flex flex-col flex-auto relative overflow-hidden transition-[filter] duration-[0.4s]" }, { children: [_jsx(PreviewNorth, {}), _jsxs("div", __assign({ className: "flex-auto bg-white overflow-auto relative" }, { children: [_jsxs("div", __assign({ className: "" }, { children: [primary && (_jsx("div", __assign({ className: "mt-4 ml-2" }, { children: _jsx(Typography, __assign({ component: "h1" }, { children: primary.name.toUpperCase() })) }))), _jsxs("div", __assign({ className: "border-b-2 py-4" }, { children: [_jsx("span", __assign({ className: "ml-2" }, { children: _jsx("button", __assign({ className: "button primary", onClick: function () {
                                                                                                                saveRecord();
                                                                                                            } }, { children: "Save Merge" })) })), _jsx("span", __assign({ className: "ml-4" }, { children: _jsx("button", __assign({ className: "button secondary", onClick: function () {
                                                                                                                navigate("/modules/".concat(module));
                                                                                                            } }, { children: t("app.LBL_CANCEL_BUTTON_LABEL", {
                                                                                                                ns: "common",
                                                                                                            }) })) }))] }))] })), _jsxs("div", __assign({ className: "flex justify-between p-4" }, { children: [primary && (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsxs("label", { children: ["Colonnes dont la valeur initiale diff\u00E8re des colonnes \u00E0 fusionner:", " "] }), _jsx(Merge, { records: primary, module: module, viewType: FieldViewType.EDIT, fieldIsUpdated: fieldIsUpdated })] }))), secondary &&
                                                                                                secondary.map(function (item) { return (_jsxs("div", __assign({ className: " w-full" }, { children: [_jsx("button", __assign({ className: "button primary", onClick: function () {
                                                                                                                setPrimary(item);
                                                                                                                setSecondary(setSecondaryFunc(records, item));
                                                                                                            } }, { children: _jsx(FontAwesomeIcon, { icon: faChevronsLeft }) })), _jsx("label", __assign({ className: "pl-2" }, { children: "Mettre comme principal" })), _jsx(Merge, { records: item, module: module, viewType: FieldViewType.DETAIL, isSecondary: true, fieldIsUpdated: fieldIsUpdated })] }))); })] })), isLoad && _jsx(LoaderImage, {})] })), _jsx(PreviewSouth, {})] })), _jsx(PreviewEast, {})] })), _jsx(DockSouth, {})] })), _jsx(DockEast, {})] })), _jsx(DrawerSouth, {})] })), _jsx(DrawerEast, {})] }))] })), _jsx(MenuEast, {})] })), _jsx(Footer, {})] })));
}
